import { z } from 'zod';
export const platformInternalNotificationAudienceCapability = 'platform.internal-notification-audience.v1';
export const platformInternalNotificationAudienceV2Capability = 'platform.internal-notification-audience.v2';
export const platformCurrentNotificationAudienceHoldCapability = 'platform.current-notification-audience-hold.v1';
export const platformInternalNotificationRoleAudienceCapability = 'platform.internal-notification-role-audience.v1';
export const platformInternalNotificationPermissionAudienceCapability = 'platform.internal-notification-permission-audience.v1';
export const platformInternalNotificationRoleKeySchema = z.string().trim().min(1).max(80)
    .regex(/^[a-z][a-z0-9-]*$/);
export const platformInternalNotificationAudienceMemberSchema = z.strictObject({
    recipientMembershipId: z.string().uuid(),
    recipientRoleKeys: z.array(platformInternalNotificationRoleKeySchema).min(1).max(20),
    subjectDisplayName: z.string().trim().min(1).max(200),
});
export const platformInternalNotificationAudienceV2MemberSchema = z.strictObject({
    recipientMembershipId: z.string().uuid(),
    directRecipient: z.boolean(),
    recipientRoleKeys: z.array(platformInternalNotificationRoleKeySchema).max(20),
    subjectDisplayName: z.string().trim().min(1).max(200),
}).superRefine((member, context) => {
    if (!member.directRecipient && member.recipientRoleKeys.length === 0) {
        context.addIssue({
            code: 'custom',
            message: 'An internal notification audience member must be direct or role-derived.',
            path: ['recipientRoleKeys'],
        });
    }
    if (new Set(member.recipientRoleKeys).size !== member.recipientRoleKeys.length) {
        context.addIssue({
            code: 'custom',
            message: 'Internal notification audience role keys must be unique.',
            path: ['recipientRoleKeys'],
        });
    }
});
//# sourceMappingURL=platform-internal-notification-audience.contract.js.map